import type { AssociateStatus } from "../types/inpact";

interface StatusBadgeProps {
  status: AssociateStatus;
  inactive?: boolean;
}

export function StatusBadge({ status, inactive = false }: StatusBadgeProps) {
  if (!status) {
    return (
      <span className="status-badge" aria-label="Associate status: none">
        —
      </span>
    );
  }
  const cls =
    status === "Associates" ? "status-badge--associates" : "status-badge--candidate";
  const icon = status === "Associates" ? "✓" : "…";
  return (
    <span
      className={`status-badge ${cls}${inactive ? " status-badge--inactive" : ""}`}
      aria-label={`Associate status: ${status}${inactive ? " (inactive)" : ""}`}
    >
      <span aria-hidden="true">{icon}</span>
      {status}
    </span>
  );
}
